import React, { Component } from 'react';
import { withTheme } from 'styled-components';
import { isEqual } from 'lodash';
import { withBreakpoints } from 'react-breakpoints';
import { AbstractChart } from 'containers/charts/AbstractChart';
import ContentTile from 'components/atoms/layout/ContentTile';
import ContentHeader from 'components/atoms/layout/ContentHeader';
import { DESKTOP_LIMIT, MOBILE_LIMIT } from 'constants/charts';
import helpers from 'helpers';

class BarChart extends Component {
    constructor(props) {
        super(props);
        this.chartRef = React.createRef();
    }

    shouldComponentUpdate(nextProps) {
        return !isEqual(nextProps, this.props);
    }

    render() {
        const series = [];
        const { orderedColors } = this.props.theme;
        const { chartRef } = this;
        let completeData;
        if (!this.props.categories) {
            completeData = helpers.backfill(
                this.props.data.map(r => ({ x: r.date_in_ms, y: r[this.props.y] })),
                this.props.backfillBuckets
            );
        } else {
            completeData = this.props.data.map(r => r[this.props.y]);
            // If flag, truncate values used in bar chart. Specifically needed
            // for SEM fractional conversion handling
            if (this.props.truncateValues) {
                completeData = completeData.map(r => Math.round(r));
            }
        }

        if (this.props.showTopOnly) {
            if (this.props.breakpoints[this.props.currentBreakpoint] >= this.props.breakpoints.sm) {
                completeData = completeData.slice(0, DESKTOP_LIMIT);
            } else {
                completeData = completeData.slice(0, MOBILE_LIMIT);
            }
        }

        series.push({
            type: 'column',
            stacking: 'normal',
            name: this.props.yAxisLabel,
            color: this.props.color || orderedColors[0],
            data: completeData
        });

        const xAxis = helpers.xAxisConfig({
            type: this.props.xAxisType,
            xAxisLabel: this.props.xAxisLabel,
            options: { categories: this.props.categories }
        });

        if (this.props.xAxisLabel) {
            xAxis.title = { text: this.props.xAxisLabel };
        } else {
            xAxis.lables = { enabled: false };
        }

        const yAxis = helpers.yAxisConfig({ yAxisLabel: this.props.yAxisLabel });
        return (
            <ContentTile padding={helpers.contentPadding('chart')}>
                <ContentHeader chartRef={chartRef} type={'chart'}>{this.props.title}</ContentHeader>
                <AbstractChart
                    ref={chartRef}
                    exportName={this.props.exportName}
                    config={{
                        meta: {
                            title: this.props.title
                        },
                        credits: {
                            enabled: false
                        },
                        title: {
                            text: null
                        },
                        chart: {
                            style: {
                                padding: 0
                            }
                        },
                        exporting: helpers.commonExportingConfig(this.props.exportName),
                        legend: {
                            enabled: this.props.legend,
                            itemStyle: {
                                color: this.props.theme.colors.darkgray
                            }
                        },
                        plotOptions: {
                            series: {
                                animation: {
                                    duration: this.props.animateDuration
                                },
                                shadow: false,
                            },
                            column: {
                                borderWidth: 0
                            }
                        },
                        xAxis,
                        yAxis,
                        series
                    }} />
            </ContentTile>
        );
    }
}

export default withTheme(withBreakpoints(BarChart));



// WEBPACK FOOTER //
// ./src/components/molecules/charts/BarChart.js